"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AbTestCampaignResultClickedLinks {
    static getAttributeTypeMap() {
        return AbTestCampaignResultClickedLinks.attributeTypeMap;
    }
}
AbTestCampaignResultClickedLinks.discriminator = undefined;
AbTestCampaignResultClickedLinks.attributeTypeMap = [
    {
        "name": "versionA",
        "baseName": "Version A",
        "type": "Array<object>"
    },
    {
        "name": "versionB",
        "baseName": "Version B",
        "type": "Array<object>"
    }
];
exports.AbTestCampaignResultClickedLinks = AbTestCampaignResultClickedLinks;
//# sourceMappingURL=abTestCampaignResultClickedLinks.js.map